import { ODSSwitch, type ODSSwitchSize } from '@telekom-ods/react-ui-kit';
import { type ComponentProps, type ComponentType, type FocusEvent } from 'react';

type SwitchLabel = string | { on: string; off: string };

interface SwitchProps {
  id?: string;
  name: string;
  label: SwitchLabel;
  checked?: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  size?: ODSSwitchSize;
}

type ODSSwitchWithNameProps = ComponentProps<typeof ODSSwitch> & {
  name?: string;
};

const TypedODSSwitch = ODSSwitch as ComponentType<ODSSwitchWithNameProps>;

export const Switch = ({
  id = '',
  name,
  label,
  checked = false,
  disabled = false,
  onChange,
  onBlur,
  size = 'small',
}: SwitchProps) => {
  let displayedLabel = '';
  if (typeof label === 'object') {
    displayedLabel = checked ? label.on : label.off;
  } else {
    displayedLabel = label;
  }

  return (
    <TypedODSSwitch
      id={id || name}
      disabled={disabled}
      size={size}
      selected={checked}
      label={displayedLabel}
      inputProps={{
        id: id || name,
        name,
        'aria-label': displayedLabel,
        onChange: event => {
          onChange(event.target.checked);
        },
        onBlur,
      }}
    />
  );
};
